import { useEffect, useRef, useState } from 'react'
import Cookies from 'js-cookie'

const useWebSocket = () => {
  const userId = Cookies.get('_uuid_socket') || Cookies.get('_uuid')
  const socketRef = useRef<WebSocket | null>(null)
  const [socketInstance, setSocketInstance] = useState<WebSocket | null>(null)
  const reconnectTimeout = useRef<any>(null)
  const isActive = useRef(false)

  const connectWebSocket = () => {
    if (!isActive.current || !userId) return

    const ws = new WebSocket(`${process.env.NEXT_PUBLIC_WS_URL}?userId=${userId}`)
    ws.onopen = () => {
      console.log('WebSocket connected')
    }

    ws.onclose = () => {
      console.warn('WebSocket closed. Attempting to reconnect...')
      if (isActive.current) {
        reconnectTimeout.current = setTimeout(connectWebSocket, 5000)
      }
    }

    ws.onerror = (error) => {
      console.error('WebSocket error:', error)
      ws.close()
    }

    socketRef.current = ws
    setSocketInstance(ws)
    isActive.current = false
  }

  useEffect(() => {
    if (userId) {
      isActive.current = true
      connectWebSocket()
    }

    return () => {
      isActive.current = false
      if (socketRef.current) {
        socketRef.current.close()
      }
      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current)
      }
    }
  }, [userId])

  return socketInstance
}

export default useWebSocket
